import { render, staticRenderFns } from "./policePage.vue?vue&type=template&id=7e9965d0&scoped=true"
import script from "./policePage.vue?vue&type=script&lang=js"
export * from "./policePage.vue?vue&type=script&lang=js"
import style0 from "./policePage.vue?vue&type=style&index=0&id=7e9965d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9965d0",
  null
  
)

export default component.exports